import React from "react";

import { Button, ButtonGroup, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { useAppDispatch } from "store";
import { ActionCreatorWithPayload } from "@reduxjs/toolkit";

const StyledButtonGroup = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.dark,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: "6px"
    },
}))(ButtonGroup);

const StyledButton = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: (props: any) => props["data-is-selected"] ? theme.palette.quaternary.light : theme.palette.quaternary.dark,
        color: theme.palette.common.white,
        borderRadius: "6px",
        "&:hover": {
            // @ts-ignore
            backgroundColor: (props: any) => props["data-is-selected"] ? theme.palette.quaternary.light : theme.palette.quaternary.dark,
            color: theme.palette.common.white,
        },
        "&.MuiButtonGroup-groupedHorizontal:not(:firs-child)": {
            border: 0,
            borderRadius: "6px"
        },
        "&.MuiButtonGroup-groupedHorizontal:not(:last-child)": {
            border: 0,
            borderRadius: "6px"
        },
        "&.MuiButtonGroup-groupedContainedHorizontal:not(:first-child)": {
            border: 0,
            borderRadius: "6px"
        },
        "&.MuiButtonGroup-groupedContainedHorizontal:not(:last-child)": {
            border: 0,
            borderRadius: "6px"
        }
    }
}))(Button);

interface ToggleButtonProps<T = string> {
    currentValue: T,
    primaryValue: T,
    primaryValueLabel: string,
    secondaryValue: T,
    secondaryValueLabel: string,
    setChosenValue: ActionCreatorWithPayload<T>
}

const ToggleButton = <T = string>(props: ToggleButtonProps<T>) => {
    const { currentValue, primaryValue, primaryValueLabel, secondaryValue, secondaryValueLabel, setChosenValue } = props;
    const dispatch = useAppDispatch();

    const handlePrimaryValueClick = () => {
        dispatch(setChosenValue(primaryValue));
    };

    const handleSecondaryValueClick = () => {
        dispatch(setChosenValue(secondaryValue));
    };

    return (
        <StyledButtonGroup
            variant="contained"
            size="medium"
            color="default"
            disableElevation
        >
            <StyledButton
                data-is-selected={currentValue === primaryValue}
                onClick={handlePrimaryValueClick}
            >
                <Typography variant="subtitle2" component="div">
                    {primaryValueLabel}
                </Typography>
            </StyledButton>
            <StyledButton
                data-is-selected={currentValue === secondaryValue}
                onClick={handleSecondaryValueClick}
            >
                <Typography variant="subtitle2" component="div">
                    {secondaryValueLabel}
                </Typography>
            </StyledButton>
        </StyledButtonGroup>
    );
};

export default ToggleButton;
